import QRGenerator from "./QRGenerator";

export default function QRTools() {
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Asset and Qr Generator</h1>
        <p className="text-gray-600">Generate QR codes for your assets</p>
      </div>
      <QRGenerator />
    </div>
  );
}
